import Vue  from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        apiURL: "",
        locale: [],
        //recaptchaScriptConnected: false,
        //recaptchaSiteKey: "",
        user: {
            name: "",
            company: {
                id: null,
                name: "",
                settings: {
                    optiSawExportURI: ""
                }
            },
            settings: {
                darkTheme:       false,
                firstRun:        true,
                miniDrawer:      false,
                patternSolidBG:  false,
                rotatePattern:   false,
                selectedSpecies: []
            },
            avatar:   "img/avatar.jpg",
            role:     1, // 1 - user, 2 - manager, 3 - admin
            loggedIn: false
        },
        subscription: {
            id:      null,
            title:   null,
            expired: null,
            limits: {
                maxUsers:    0,
                maxPatterns: 0,
                maxModels:   0,
                maxLines:    0
            },
            settings: {
                optimization: {
                    denyExport:    true, // Запретить экспорт
                    lockCoreless:  true, // Блокировать изменение параметра использования бессердцевинной доски
                    lockCurvature: true, // Блокировать изменение параметров кривизны
                    lockWane:      true, // Блокировать изменение параметра расчёта с учётом обзола
                },
                lengths: {
                    lock: true, // Блокировать изменение справочника длин
                },
                lumber: {
                    lock: true, // Блокировать изменение справочника пиломатериалов
                },
                patterns: {
                    denyEdit:   true, // Запретить редактирование поставов
                    denyExport: true, // Запретить экспорт
                    denyImport: true, // Запретить импорт
                },
            }
        },
        settings: {
            volCalc: {
                method:   "standartTables",
                standard: "gost2708_75"
            },
            wane: {
                width:                 15,
                cutAlongEdge:          75,
                cutAlongPlate:         75,
                maxLength:             0,
                wanelessCentralBoards: true,
            },
            report: {
                title: "",
                displayPrice: true,
                displayPatternSizes: true
            },
            woodChipsCoef: 1,
            lumberShrinkageCalcMethod: "fromLogVolume",
            lumberWaneCalcMethod: "rectangle"
        },
        miniNavigationMenu: false,
        helpDisplayed:      false,
        optiSawExportURI: "",
        calculationTask: {
            id:         0,
            calculated: false
        }
    },

    getters: {
        apiURL:             state => { return state.apiURL; },
        locale:             state => { return state.locale; },
        user:               state => { return state.user; },
        subscription:       state => { return state.subscription; },
        settings:           state => { return state.settings; },
        miniNavigationMenu: state => { return state.miniNavigationMenu; },
        calculationTask:    state => { return state.calculationTask; },
        helpDisplayed:      state => { return state.helpDisplayed; }
        //recaptchaScriptConnected: state => { return state.recaptchaScriptConnected; },
        //recaptchaSiteKey: state => { return state.recaptchaSiteKey; }
    },

    mutations: {
        setApiURL             (state, payload) { state.apiURL             = payload; },
        setLocale             (state, payload) { state.locale             = payload; },
        setUser               (state, payload) { state.user               = payload; },
        setSubscription       (state, payload) { state.subscription       = payload; },
        setSettings           (state, payload) { state.settings           = payload; },
        setMiniNavigationMenu (state, payload) { state.miniNavigationMenu = payload; },
        setCalculationTask    (state, payload) { state.calculationTask    = payload; },
        setHelpDisplayed      (state, payload) { state.helpDisplayed      = payload; }
        //setRecaptchaScriptConnected (state, payload) { state.recaptchaScriptConnected = payload },
        //setRecaptchaSiteKey (state, payload) { state.recaptchaSiteKey = payload; }
    }
});

//export default store